import { RouteConfig } from 'vue-router/types/router';
import MswLookupTool from './lookupTool.vue';

export const lookupTool: RouteConfig = {
  path: 'lookup-tool',
  component: MswLookupTool,
};
